module.exports = __webpack_public_path__ + "img/feature-playlists@2x.b5c9b078.png";